var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner',{attrs:{"defaultMenu":0}}),_c('yindao'),_c('beian')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }